import { render, staticRenderFns } from "./FGlist.vue?vue&type=template&id=52129654&"
import script from "./FGlist.vue?vue&type=script&lang=js&"
export * from "./FGlist.vue?vue&type=script&lang=js&"
import style0 from "./FGlist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports